<template>
  <div>
    <TModal
      v-if="visibleModal"
      md
      dark
      header-low
      :header="label"
      @close="() => (visibleModal = false)"
    >
      <template #dialog-body>
        <div
          class="font-regular px-5 pb-6 font-inter text-sm leading-6 text-gray-50"
        >
          <div
            class="mb-3 rounded border border-solid p-2"
            :class="{
              'border-happy text-happy': good,
              'border-meh text-meh': middle,
              'border-sad text-sad': bad,
            }"
          >
            {{ modalStatusTetx }}
          </div>
          <div v-if="!good" class="a-accent" v-html="modalExplainText"></div>
        </div>
      </template>
    </TModal>
    <div class="flex items-center gap-2">
      <TLabel>{{ label }}</TLabel>
      <div
        v-if="!loading"
        class="flex cursor-pointer items-center gap-1 rounded-md bg-gray-900 py-1 pl-2 pr-1.5"
        :class="{
          'text-happy': good,
          'text-meh': middle,
          'text-sad': bad,
        }"
        @click="visibleModal = true"
      >
        <span class="font-inter text-[13px] font-semibold leading-6">
          {{ skore }}
        </span>
        <font-awesome-icon v-if="good" :icon="['fas', 'face-smile']" />
        <font-awesome-icon
          v-if="middle"
          class="animate-pulse"
          :icon="['fas', 'face-meh']"
        />
        <FaceWorried v-if="bad" class="animate-pulse" />
      </div>
      <div
        v-if="loading"
        class="flex cursor-pointer items-center gap-1 rounded-md bg-gray-900 py-1 pl-2 pr-1.5"
      >
        <TLoadingSpinner />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { FaceWorried } from "@topol/icons";
  import { TLabel, TLoadingSpinner, TModal } from "@topol/twig-ui";
  import { ref } from "vue";

  defineProps({
    label: {
      type: String,
      required: true,
    },
    skore: {
      type: String,
      required: true,
    },
    good: {
      type: Boolean,
      default: false,
    },
    middle: {
      type: Boolean,
      default: false,
    },
    bad: {
      type: Boolean,
      default: false,
    },
    modalStatusTetx: {
      type: String,
      default: "",
    },
    modalExplainText: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  });

  const visibleModal = ref(false);
</script>

<style lang="scss">
  .a-accent {
    a {
      color: var(--c-accent-2);
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
</style>
